import { useEffect, useRef } from 'react'

export const usePreserveBackgroundScroll = (isOpen: boolean) => {
    const scrollPositionRef = useRef<number | null>(null)

    useEffect(() => {
        if (typeof window === 'undefined') {
            return
        }

        const restoreScroll = () => {
            if (scrollPositionRef.current === null) {
                return
            }

            window.scrollTo(0, scrollPositionRef.current)
        }

        if (isOpen) {
            if (scrollPositionRef.current === null) {
                scrollPositionRef.current = window.scrollY
            }

            restoreScroll()

            const animationFrame = window.requestAnimationFrame(restoreScroll)
            const timeout = window.setTimeout(restoreScroll, 0)

            return () => {
                window.cancelAnimationFrame(animationFrame)
                window.clearTimeout(timeout)
            }
        }

        if (scrollPositionRef.current !== null) {
            restoreScroll()

            const animationFrame = window.requestAnimationFrame(() => {
                restoreScroll()
                scrollPositionRef.current = null
            })
            const timeout = window.setTimeout(() => {
                restoreScroll()
                scrollPositionRef.current = null
            }, 0)

            return () => {
                window.cancelAnimationFrame(animationFrame)
                window.clearTimeout(timeout)
            }
        }
    }, [isOpen])
}
